import { render, staticRenderFns } from "./form-summary.vue?vue&type=template&id=230a44b6&scoped=true"
import script from "./form-summary.vue?vue&type=script&setup=true&lang=js"
export * from "./form-summary.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-captcha/dist/vue-captcha.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@ui-common/vue-error-message/dist/vue-error-message.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./form-summary.vue?vue&type=style&index=2&id=230a44b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a44b6",
  null
  
)

export default component.exports